import AsyncStorage from '@react-native-async-storage/async-storage';
import { COUNTRY } from '../../common/constants';

export async function getServerEndpoint (isWebsocket) {
	const protocol = isWebsocket ? 'ws' : 'http';

	// eslint-disable-next-line no-undef
	if (__DEV__) {
		console.log('ip: ', process.env.__API_ADDRESS__);
	}

	// eslint-disable-next-line no-undef
	if (__DEV__ && process.env.__API_ADDRESS__) {
		return `${protocol}://${process.env.__API_ADDRESS__}`;
	}

	const region = await AsyncStorage.getItem('region');

	if (region && region !== COUNTRY.AUSTRALIA) {
		return `${protocol}s://api.${region}.sentryvend.com`;
	}

	return `${protocol}s://api.sentryvend.com`;
}
